import { Injectable, inject } from '@angular/core';

import { ColumnLayoutService } from './column-layout.service';
import { ColumnComponentRegistration, ColumnSize, LayoutColumn } from './layout.model';

@Injectable({ providedIn: 'root' })
export class ColumnLayoutRegister {
    private columnLayout = inject(ColumnLayoutService);

    private resized: LayoutColumn[] = [];

    register(registration: ColumnComponentRegistration): void {
        this.columnLayout.register(registration);
    }

    resizeColumn(size: ColumnSize, column: LayoutColumn): void {
        if (this.resized.indexOf(column) !== -1) {
            this.resized.push(column);
        }

        this.columnLayout.setColumnSize(size, column);
    }
}
